import { render } from "./RouteInfo.vue?vue&type=template&id=371ed1be&scoped=true"
import script from "./RouteInfo.vue?vue&type=script&lang=js"
export * from "./RouteInfo.vue?vue&type=script&lang=js"

import "./RouteInfo.vue?vue&type=style&index=0&id=371ed1be&lang=scss&scoped=true"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371ed1be"]])

export default __exports__